import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import Marquee from "react-fast-marquee";
interface AppMarqueePropsType extends GeneralPropsType {
  play?: boolean; // Set to true to play the marquee automatically on mount. Default is false.
  useBackGround?: boolean; // Set to true to
  speed?: number;
}
function AppMarquee({
  children,
  className,
  play,
  useBackGround = true,
  speed
}: AppMarqueePropsType) {
  return <div className={clsx(useBackGround ? styles.container : "", className)} data-sentry-component="AppMarquee" data-sentry-source-file="index.tsx">
            <Marquee play={play} speed={speed} data-sentry-element="Marquee" data-sentry-source-file="index.tsx">
                {children}
            </Marquee>
        </div>;
}
export default AppMarquee;